import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function CaretDown(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "10px", viewBox: "0 0 10 10", width: "10px" }, props),
        React.createElement("path", { d: "m5 8.00410837c-.26558565.00152002-.52085494-.10283023-.70941946-.29001674l-3.99672938-4c-.39180155-.39212217-.39180155-1.02787783 0-1.42s1.02703738-.39212217 1.41883893 0l3.28730991 3.29 3.28730991-3.29c.39180155-.39212217 1.02703738-.39212217 1.41883893 0 .39180156.39212217.39180156 1.02787783 0 1.42l-3.99672938 4c-.18856452.18718651-.44383381.29153676-.70941946.29001674z" })));
}
